import React from 'react'
import ButtonCustom from '../button/ButtonCustom'
import styles from './InvoiceTemplate.module.scss'

const InvoiceTemplate = ({
	image = '/images/InvoiceTemplate01.svg',
	title = 'Standard',
	description = 'A simple, professional invoice template',
	selected = false,
	onSelect,
}) => {
	return (
		<div
			className={`
                ${styles.invoiceTemplate}
                ${selected ? styles.selected : ''}
            `}
			onClick={onSelect}
		>
			<div className={styles.invoiceTemplateImg}>
				<img src={image} alt={title} />
				<ButtonCustom
					variant="outlined"
					size="small"
					className={styles.invoiceTemplateBtn}
				>
					<img src="/images/eye-open-icon.svg" alt="eye-open-icon" />
				</ButtonCustom>
			</div>
			<div className={styles.invoiceTemplateText}>
				<p className={styles.invoiceTemplateTextHeading}>
					{title}{' '}
					<img
						src="/images/SelectCheck.svg"
						alt="SelectCheck"
						className={`${selected ? styles.ImgSelected : ''}`}
					/>
				</p>
				<p className={styles.invoiceTemplateTextSubHeading}>
					{description}
				</p>
			</div>
		</div>
	)
}

export default InvoiceTemplate
